import { baseService } from "service/base";

class EventNameService {
  load() {
    return baseService.get("/api/events/v3/names");
  }
}

const eventNameService = new EventNameService();

export { eventNameService };
